export default __webpack_public_path__ + "static/embla-logo-dark-theme-blur-dd6671f5992e7089fd82e1f04db7370e.svg";